<template>
  <RouterLink
    :to="to"
    class="logo"
    :class="`logo--${variant}`"
  >
    <img
      :src="currentLogo"
      :alt="alt"
      width="240"
      height="60"
      decoding="async"
      fetchpriority="high"
    />
  </RouterLink>
</template>

<script>
import logoNavy from '@/assets/images/LOGO FIX LANDSCAPE TP NAVY.svg'
import logoWhite from '@/assets/images/LOGO FIX LANDSCAPE TP WHITE.svg'

export default {
  name: 'LogoComponent',

  props: {
    to: {
      type: String,
      default: '/'
    },

    alt: {
      type: String,
      default: 'DITAP'
    },

    variant: {
      type: String,
      default: 'default'
    }
  },

  data() {
    return {
      currentTheme: 'light',
      themeObserver: null
    }
  },

  computed: {
    currentLogo() {
      return this.currentTheme === 'dark'
        ? logoWhite
        : logoNavy
    }
  },

  mounted() {
    this.updateTheme()

    this.themeObserver = new MutationObserver(() => {
      this.updateTheme()
    })

    this.themeObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    })
  },

  beforeUnmount() {
    this.themeObserver?.disconnect()
  },

  methods: {
    updateTheme() {
      this.currentTheme =
        document.documentElement.dataset.theme || 'light'
    }
  }
}
</script>